import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const CartOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.46842 5.33191H0L0.490335 10.4888H0.491982C0.865624 13.8665 2.28813 15.0001 6.07643 15.0001H9.91967C13.708 15.0001 15.1305 13.8665 15.5041 10.4888H15.5058L15.9961 5.33191H13.5271L10.2204 1.00012L9.10756 1.84961L11.7658 5.33191H4.2297L6.88795 1.84961L5.77513 1.00012L2.46842 5.33191ZM1.88349 10.3348L1.87295 10.2395L1.53943 6.73191H14.4567L14.1231 10.2395L14.1126 10.3348C13.9409 11.8866 13.5612 12.5607 13.1141 12.9209C12.6263 13.3138 11.7368 13.6001 9.91967 13.6001H6.07643C4.25926 13.6001 3.36981 13.3138 2.88202 12.9209C2.43491 12.5607 2.05515 11.8866 1.88349 10.3348Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const CartOutlinedSize16 = hoc(forwardRef(CartOutlinedSize16Component), 'CartOutlinedSize16');

export { CartOutlinedSize16 as default };
//# sourceMappingURL=CartOutlinedSize16.js.map
